/**
 * A session's trainers as the API hands them out: `[{ staffId, name, email,
 * position, department, role, factor, sortOrder }]`, leads first. Shared
 * wording for the two roles and the one-line "who runs it" string.
 */

export const TRAINER_ROLE_LABEL = {
  lead: 'Lead Trainer',
  assistant: 'Assistant Trainer',
};

export const trainerRoleLabel = (role) => TRAINER_ROLE_LABEL[role] || 'Trainer';

/** The lead trainers' names as one string, or null when none is booked. */
export const leadTrainerNames = (trainers) => {
  const names = (trainers || []).filter((t) => t.role === 'lead').map((t) => t.name).filter(Boolean);
  return names.length > 0 ? names.join(', ') : null;
};

export const assistantTrainers = (trainers) => (trainers || []).filter((t) => t.role === 'assistant');
